export function getApiUrl(path: string) {
  return `${document.location.protocol}//${document.location.host}${process.env.PUBLIC_URL}/api${path}`;
}

export async function doGET(path: string) {
  const res = await fetch(getApiUrl(path), {
    method: "get",
    mode: "cors",
  });
  return prepareRes(res);
}

export async function doPOSTJSON(path: string, body: any) {
  const res = await fetch(getApiUrl(path), {
    method: "post",
    mode: "cors",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
  return prepareRes(res);
}

async function prepareRes(res: Response) {
  if (res.status < 200 || res.status >= 300) {
    throw new Error(`${res.status} ${res.statusText}`);
  }
  if (res.status == 204) {
    return null;
  }
  return await res.json();
}

var notLoggedInShownAt = 0;

export async function checkLoggedIn() {
  if (!(await isLoggedIn())) {
    if (Date.now() - notLoggedInShownAt > 5 * 60 * 1000) {
      notLoggedInShownAt = Date.now();
      // alert("Not logged in, please reload the browser");
    }
  }
}

export async function isLoggedIn() {
  try {
    const email = await doGET("/me")
    return email != "";
  } catch (e) {
    console.error(e);
  }
  return false;
}